import api from "@/apis/JobPositionAssetAPI";
import Crud from "./crud-base";
var crud = new Crud("JobPositionAsset", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "JobPositionID",
      code: "JobPositionCode",
      name: "JobPositionName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
